export default "__VITE_ASSET__BCc9QD64__"